import { actions, selectors } from 'app-webtech-core';
import { actionCreator } from 'app-webtech-core/actions/actionCreator';
import { prepareEndpointWithState } from 'app-webtech-core/store/plutoApiInjectorMiddleware';
import bootstrapURL from 'app-modules/application/utils/bootstrapURLFromStorage';

import url from 'url';

import { SET_SESSION_TOKEN, SESSION_TOKEN_REFRESHED, BOOTSTRAP_RESTART_REQUEST } from './types';

const setSessionTokenAction = actionCreator(SET_SESSION_TOKEN);
const sessionTokenRefreshedAction = actionCreator(SESSION_TOKEN_REFRESHED);
const bootstrapRestartRequest = actionCreator(BOOTSTRAP_RESTART_REQUEST);

async function resetBootstrapData(getState, { lastActionDate }) {
  const endpoint = prepareEndpointWithState(
    `${bootstrapURL().getBootstrapURL() || process.env.BOOTSTRAP_BASE_URL}/v4/restart`,
    getState(),
    true,
  );
  const state = getState();
  const { sessionToken } = state.application;
  // Re-parsing the endpoint url to include missing parameters that bootstrap require
  const parsedEndpoint = url.parse(endpoint, true);
  parsedEndpoint.query = {
    ...parsedEndpoint.query,
    lastEventTime: Math.round(lastActionDate / 1000),
    clientID: parsedEndpoint.query.deviceId,
    clientModelNumber: 'na',
  };
  parsedEndpoint.search = undefined;
  const bootstrapUrl = url.format(parsedEndpoint);
  const headers = { Authorization: `Bearer ${sessionToken}` };

  const response = await fetch(bootstrapUrl, { headers });
  return response.json();
}

export const refreshTokenActionThunkAction = (payload) => async (dispatch, getState) => {
  const { ID: oldID } = selectors.playbackSession.properties(getState());
  await dispatch(bootstrapRestartRequest());
  let sessionToken;
  let sessionID;
  let error;
  try {
    ({
      session: { sessionID },
      sessionToken,
      error,
    } = await resetBootstrapData(getState, payload));
  } catch (e) {
    dispatch(setSessionTokenAction(new Error('Connectivity Error')));
    return false;
  }
  if (error) {
    dispatch(setSessionTokenAction(new Error('Connectivity Error')));
    return false;
  }

  await dispatch(setSessionTokenAction({ sessionToken }));
  if (sessionID !== oldID) {
    await dispatch(actions.playbackSession.setID({ ID: sessionID }));
    dispatch(sessionTokenRefreshedAction(payload));
    return oldID;
  }
  return false;
};
